module.exports = __webpack_public_path__ + "img/no-logo.bd4b85f.svg";